import { Component } from "@angular/core";
import { AppConstants } from "@core/constants/app";
import { TranslateService } from "@ngx-translate/core";
import { ConfigService } from "@core/data/config.service";

@Component({
    selector: "app-blue-button",
    templateUrl: "./blue-button.component.html",
    styleUrls: ["./blue-button.component.scss"],
    standalone: false,
})
export class BlueButtonComponent {
    public readonly translationPrefix = "pages.blueButtonPage";
    public blueButton: { termsUrl: string; privacyUrl: string };

    constructor(
        private conf: ConfigService,
        private translate: TranslateService,
    ) {
        this.blueButton = {
            termsUrl: AppConstants.TERMS_AND_CONDITIONS_URL_MAPPING()[this.translate.currentLang],
            privacyUrl: AppConstants.PRIVACY_POLICY_URL_MAPPING()[this.translate.currentLang],
        };
    }

    public blueButtonClick() {
        window.open(this.conf.getBlueButtonConfig["url"], "_blank");
    }
}
